import React from 'react';
import { Route, Switch } from "react-router-dom";
import AllTajweedView from './AllTajweedView';
import TajweedLessonView from "./TajweedLessonView";

const TajweedRoutes = () => (
    <Switch>
      <Route exact path="/tajweed" component={AllTajweedView}/>
      <Route exact path="/tajweed/:tajweedNumber" component={TajweedLessonView}/>
      <Route component={AllTajweedView} />
    </Switch>
  )
  export default TajweedRoutes;